import React, { ReactNode } from 'react'
import Box from '../primitives/Box'

/**
 * Reset global CSS styles for new pages
 */
const GlobalStyleReset = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      css={`
        /* Override basic styles*/
        .gatsby-image-wrapper img {
          max-width: 100%;
          width: auto;
          height: auto;
        }

        letter-spacing: 0;
      `}
    >
      {children}
    </Box>
  )
}

export default GlobalStyleReset
